import {DealDasDao} from '../../dao';
import {DasModel} from '../../models';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'UPDATE_CUSTOMER_CATEGORY_BY_ID';

export async function updateDas(
    userData: Record<string, string>,
    dasId: number,
    update: Record<string, any>
) {
    try {
        const result = await DealDasDao.updateDealDas(userData.userToken, dasId, update);

        const resultParsed = DasModel.parseDas(result);

        return resultParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
